<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" @add="novoRegistro" 
        :isSearch="true" @search="goSearch">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados do Medicamento</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs11 md7 lg7>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nmNome" label="Nome" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md4 lg4>
                    <v-text-field v-model.trim="registro.nrExterno" label="Código na empresa" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs11 md4 lg4>
                    <v-text-field type="number" v-model.number="registro.nrDiasCarencia" label="Carência (dias)" outlined>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5 v-if="farmacoInjetavel">
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.csTipoAdm" :items="listTiposAdministracao"
                        color="primary" item-text="dsTipo" item-value="stTipo" label="Via de Administração"
                                    @change="changeTipoFarmaco"
                        no-data-text="Nenhum registro" outlined clearable>
                    </v-autocomplete>
                </v-flex>
                <v-flex class="item" xs11 md7 lg7 v-else>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.csTipoAdm" :items="listTiposAdministracao"
                        color="primary" item-text="dsTipo" item-value="stTipo" label="Via de Administração" @change="changeTipoFarmaco"
                        no-data-text="Nenhum registro" outlined clearable>
                    </v-autocomplete>
                </v-flex>
                <v-flex class="item" xs11 md2 lg2 v-if="farmacoInjetavel" pl-2>
                    <v-switch color="primary" v-model="registro.flVacina" label="Vacina" ></v-switch>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados de Dosagem</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center="" v-if="farmacoInjetavel">
                <v-flex class="item" xs11 md4 lg4>
                    <v-switch color="primary" v-model="registro.flDoseFixa" label="Dose Fixa por animal" ></v-switch>
                </v-flex>
                <v-flex class="item" xs11 md7 lg7>
                    <v-text-field :rules="[isAValidFloat]" v-model.trim="registro.nrDosePorQuilo" 
                        :label='registro.flDoseFixa ? "Dose (por animal)" : "Dose (por kg)"' outlined clearable>
                    </v-text-field>
                </v-flex>                
            </v-layout>
            <v-layout row wrap justify-center="">
                <v-flex class="item" xs11 md11 lg11>
                    <v-text-field  :rules="[tamanhoMaximoDezesseis]" v-model.trim="registro.csUnidadeMedidaDosagem" label="Unidade de Medida Dosagem" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados adicionais</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center="">
                <v-flex class="item" xs11 md11 lg11>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.cdLaboratorio" :items="laboratorios"
                        color="primary" item-text="nmLaboratorio" item-value="idLaboratorio" label="Selecione o laboratório por nome"
                        no-data-text="Nenhum registro" outlined clearable>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center="">
                <v-flex class="item" xs11 md11 lg11>
                    <v-text-field v-model.trim="registro.dsIndicacoes" label="Indicações" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap justify-center="">
                <v-flex class="item" xs11 md11 lg11>
                    <v-autocomplete v-model="listPrincipiosAtivo" :items="principiosAtivos" filled chips outlined
                        label="Princípios ativos" item-text="nmPrincipioAtivo" item-value="idPrincipioAtivo" multiple>
                        <template slot="selection" slot-scope="data" >
                            <v-chip :input-value="data.selected" close class="chip--select-multi" @click:close="removePrincipio(data.item)" >
                                {{ data.item.nmPrincipioAtivo }}
                            </v-chip>
                        </template>
                        <template slot="item" slot-scope="data" >
                            <template>
                                <v-list-item-content>
                                    <v-list-item-title v-html="data.item.nmPrincipioAtivo"></v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </template>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio, isAValidFloat, tamanhoMaximoDezesseis } from '@/filters/rules'
import { TituloShouldNavigate,
        MensagemShouldNavigate,
        MensagemSuccessSave } from '@/resourceMessageFile.js'
import { mask } from 'vue-the-mask'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'

export default {
    name: 'Farmaco',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
    },
    directives: {
        mask,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            registroBanco: {},
            isLoading: false,
            selected: [],
            stMedicada: false,
            farmacoInjetavel: false,
            listPrincipiosAtivo: [],
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Medicamento: ' + this.registro.idFarmaco

                return 'Inserindo novo Medicamento'
            }
        },
        tiposFarmaco () {
            return this.$store.state.tiposFarmaco
        },
        laboratorios () {
            return this.$store.state.laboratorios
        },
        principiosAtivos () {
            return this.$store.state.principiosAtivos
        },
        listTiposAdministracao() {
        	return [
	          {
	              stTipo: 'RA',
	              dsTipo: 'Ração'
	          },
						...this.$store.state.tiposAdmFarmaco,
        ]},
    },
    methods: {
        campoObrigatorio,
        campoSelectObrigatorio,
        isAValidFloat,
        tamanhoMaximoDezesseis,
        removePrincipio (item) {
            const index = this.listPrincipiosAtivo.indexOf(item.idPrincipioAtivo)
            if (index >= 0) this.listPrincipiosAtivo.splice(index, 1)
        },
        changeTipoFarmaco(val) {
            this.registro.nrDosePorQuilo = 0
            if (val == "IJ")
            {
                this.farmacoInjetavel = true
            }
            else    
            {
                this.farmacoInjetavel = false
            }
        },
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadTiposFarmaco')
            this.$store.dispatch('actLoadLaboratorios')
            this.$store.dispatch('actLoadPrincipiosAtivos')
            this.$store.dispatch('actLoadFarmacos')
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            var context = this
            this.$axios.get('farmaco/' + id)
                .then((response) => {
                    var rec = response.data[0].data
                    context.listPrincipiosAtivo = []
                    if (rec.principiosAtivo.length > 0)
                    {
                        rec.principiosAtivo.forEach(function (item) {
                            context.listPrincipiosAtivo.push(item.idPrincipioAtivo)
                        })
                    }
                    if (rec.csTipoAdm == 'IJ')
                    {
                        this.farmacoInjetavel = true
                    }
                    this.registro.nrDosePorQuilo = this.registro.nrDosePorQuilo != null ? this.registro.nrDosePorQuilo.toLocaleString('pt-br').replace('.', '') : 0
                    this.registro = Object.assign({}, rec)
                    this.registroBanco = Object.assign({}, rec)
                    this.changeViewState('endLoading')
                })
                .catch((error) => {
                    this.changeViewState('isError', error)
                    this.$router.push({ path: '/farmaco'})
                })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.registro.nrDiasCarencia = this.registro.nrDiasCarencia == "" ? 0 : this.registro.nrDiasCarencia
            this.registro.cdLaboratorio = this.registro.cdLaboratorio == '' ? null : this.registro.cdLaboratorio
            this.registro.lstCdPrincipioAtivos = this.listPrincipiosAtivo
            if (this.farmacoInjetavel)
            {
                var floatNrDoseQuilo = this.registro.nrDosePorQuilo.toString().replace(',', '.')
                this.registro.nrDosePorQuilo = parseFloat(parseFloat(floatNrDoseQuilo).toFixed(3))
            }
            this.$axios.post('farmaco/', this.registro)
                .then((response) => {
                    this.$router.replace({ name: 'farmaco', params: { id: response.data[0].data.idFarmaco }})
                    this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                    this.changeViewState('endLoading')
                    this.$store.dispatch('actLoadFarmacos')
                })
                .catch((error) => {
                    this.changeViewState('isError', error)
                })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.registro.nrDiasCarencia = this.registro.nrDiasCarencia == "" ? 0 : this.registro.nrDiasCarencia
            this.registro.lstCdPrincipioAtivos = this.listPrincipiosAtivo
            if (this.farmacoInjetavel)
            {
                var floatNrDoseQuilo = this.registro.nrDosePorQuilo.toString().replace(',', '.')
                this.registro.nrDosePorQuilo = parseFloat(parseFloat(floatNrDoseQuilo).toFixed(3))
            }
            this.$axios.put('farmaco/' + this.registro.idFarmaco, this.registro)
                .then(() => {
                    this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                    this.initViewFromRoute(this.$route)
                    this.$store.dispatch('actLoadFarmacos')
                })
                .catch((error) => {
                    this.changeViewState('isError', error)
                })
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
                .then(confirm => {
                    if (confirm)
                        this.deleteRegistro()
                })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('farmaco/' + this.registro.idFarmaco)
                .then(() => {
                    this.$router.go(-1)
                    this.changeViewState('endLoading')
                    this.$store.dispatch('actLoadFarmacos')
                })
                .catch((error) => {
                    this.changeViewState('isError', error)
                })
        },
        novoRegistro() {
            this.$router.push({ path: '/farmaco' })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idFarmaco: 0,
                nmNome: '',
                nrDiasCarencia: 0,
                nrDosePorQuilo: 0,
                cdLaboratorio: 0,
                cdTipoFarmaco: null,
                nrExterno: '',
                csUnidadeMedidaDosagem: '',
                principiosAtivo: [],
                dsIndicacoes: '',
                csTipoAdm: '',
                flVacina: false,
                flDoseFixa: false
            }
            this.registroBanco = {
                idFarmaco: 0,
                nmNome: '',
                nrDiasCarencia: 0,
                nrDosePorQuilo: 0,
                cdLaboratorio: 0,
                cdTipoFarmaco: null,
                nrExterno: '',
                csUnidadeMedidaDosagem: '',
                principiosAtivo: [],
                dsIndicacoes: '',
                csTipoAdm: '',
                flVacina: false,
                flDoseFixa: false
            }
        },
        goSearch() {
            this.$router.push({ path: '/farmacoSearch' })
        },
        shouldNavigate(to, from, next) {
            if (JSON.stringify(this.registro) !== JSON.stringify(this.registroBanco) && !this.isLoading)
            {
                this.$root.$confirm(TituloShouldNavigate, MensagemShouldNavigate, { color: 'red', width: 400 })
                    .then(confirm => {
                        next(confirm)
                        return confirm
                    })
            }
            else
            {
                next()
                return true
            }
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
    beforeRouteUpdate(to, from, next){
        this.shouldNavigate(to, from, next)
    },
    beforeRouteLeave (to, from, next) {
        this.shouldNavigate(to, from, next)
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
